/* KPLENTY v67 (2026-10-13): welcome 20% signup popup (Shopify Forms).
   - The store is English-only now: hide the "Email language" choice and keep English selected,
     so the existing welcome workflow still receives email_language = en.
   - Center the "Get my 20% offer" label inside the button (the button had content-box sizing,
     so its padding was added on top of the fixed height and the label sat high).
   - Without the language choice the header block (flex-grow) stretched and left a large gap above
     the email field; keep it at its natural height so the text and form sit together.
   - Mobile: the offer sentence goes from 13px to 15px (same as desktop) for easier reading. */
(() => {
  if (window.__kpV67Forms) return;
  window.__kpV67Forms = true;

  const selector = 'shopify-forms-embed#app-embed-container-1178935';
  const styleId = 'kp-v67-forms-polish';
  const englishId = 'custom#email_language-en';
  const fieldName = 'custom#email_language';
  const css = `
form[data-testid="form"] fieldset[name="custom#email_language"]{display:none!important;}
section[data-sizing="form-wrapper"][role="dialog"] > div:has(> form[data-testid="form"]) > section{flex:0 0 auto!important;margin-bottom:0!important;}
form[data-testid="form"] button[data-testid="btn-form-submit"][type="submit"]{
  box-sizing:border-box!important;display:flex!important;align-items:center!important;justify-content:center!important;
  height:52px!important;min-height:52px!important;max-height:52px!important;padding:0 20px!important;
  line-height:1.2!important;text-align:center!important;
}
@media(max-width:760px){
  form[data-testid="form"] button[data-testid="btn-form-submit"][type="submit"]{height:48px!important;min-height:48px!important;max-height:48px!important;}
  section[data-sizing="form-wrapper"][role="dialog"] > div:has(> form[data-testid="form"]) > section > div > p{font-size:15px!important;line-height:1.45!important;}
}
`;

  const keepEnglish = root => {
    const english = root.getElementById(englishId);
    if (!english || english.type !== 'radio' || english.name !== fieldName || english.disabled) return;
    if (!english.checked) english.click();
  };

  let host = null;
  let root = null;
  let rootObserver = null;
  let frame = 0;
  let retries = 0;

  const apply = () => {
    frame = 0;
    const nextHost = document.querySelector(selector);
    const nextRoot = nextHost && nextHost.shadowRoot;
    if (nextHost !== host || nextRoot !== root) {
      if (rootObserver) rootObserver.disconnect();
      host = nextHost;
      root = nextRoot;
      if (root) {
        rootObserver = new MutationObserver(() => schedule());
        rootObserver.observe(root, { childList: true, subtree: true });
      }
    }
    if (root) {
      retries = 0;
      if (!root.getElementById(styleId)) {
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = css;
        root.appendChild(style);
      }
      keepEnglish(root);
    } else if (retries-- > 0) {
      frame = requestAnimationFrame(apply);
    }
  };

  const schedule = (retry = 0) => {
    retries = Math.max(retries, retry);
    if (!frame) frame = requestAnimationFrame(apply);
  };

  const start = () => {
    new MutationObserver(() => {
      const nextHost = document.querySelector(selector);
      if (nextHost !== host || (nextHost && nextHost.shadowRoot !== root)) schedule(60);
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('load', () => schedule(60), { once: true });
    if (window.customElements) customElements.whenDefined('shopify-forms-embed').then(() => schedule(60));
    schedule(60);
  };

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });
})();
